// extracted by mini-css-extract-plugin
export var active = "_9x-7";
export var container = "_9x-0";
export var evenWidth = "_9x-4";
export var large = "_9x-5";
export var outlet = "_9x-8";
export var slide = "_9x-2";
export var small = "_9x-6";
export var tab = "_9x-3";
export var tabs = "_9x-1";